import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavService {
  menuOpen = signal<boolean>(false);
  
  show(){
    this.menuOpen.set(true);
  }

  hide(){
    this.menuOpen.set(false);
  }

  toggle(){
    this.menuOpen() === true ? this.hide() : this.show();
  }

  isMenuOpen(): boolean {
    return this.menuOpen();
  }
}
